<template>
    <div class="CoHeader">
        <van-sticky>
            <div
                :class="{'Coheader':true,'headerDark':isDark, 'headerBgNone': bgNone, webHeader: !isAppOpen}"
                :style="{'height':(parseFloat(topBar) + parseFloat(statusBar)) / 37.5 + 'rem','padding-top': parseFloat(statusBar) / 37.5  + 'rem'}"
            >
                <i v-if="true || isAppOpen" class="return"  @click="returnTop"></i>
                <span :class="{transparent: titleTransparent && transparent}">
                    {{title || titleTransparent}}
                </span>
                <template>
                    <span class="search">
                        <van-icon v-if="showSearch" name="search" @click="goSearch" />
                        <van-icon v-if="showShare" name="share" @click="Share"/>
                    </span>
                </template>
                <slot></slot>
            </div>
        </van-sticky>
    </div>
</template>

<script>
import { handleLocalStorage, isJHApp } from "@/utils/base"
import jsbridg from "@/utils/jsbridg.js"
export default {
    name: "headSssembly",
    props: ['isDark', 'height', 'title', 'titleTransparent', 'showSearch', 'showShare', 'type', 'bgNone'],
    data () {
        return {
            isAppOpen: isJHApp(),
            statusBar: handleLocalStorage('get', 'statusBar') || 40,
            topBar: handleLocalStorage('get', 'topBar') || 44,
            whiteArrows: require("../../assets/img/common/backLight.png"),
            blackArrows: require("../../assets/img/common/backBlack.png"),
            transparent: true
        }
    },
    methods: {
        Share () {
            this.$emit('share')
        },
        goSearch () {
            jsbridg.goGlobalSearch()
        },
        download () {
            this.$v.appCheckUpdate()
        },
        returnTop () {
            // this.$v.appPageQuit()
            // if (this.isAppOpen) {
            //     if (isAndroid() === 1) {
            //         jsbridg.closeWebview()
            //     } else {
            //         jsbridg.goBack()
            //     }
            // } else {
            this.$router.go(-1)
            // }
        }
    }
}
</script>

<style lang="less" scoped>
.CoHeader{
    .Coheader{
        position: relative;
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-size:16px;
        font-weight:400;
        background: #fff;
        color:#333;
        overflow: hidden;
        &.webHeader{
            height: 45px !important;
            padding: 0 !important;
        }
        .return{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 45px;
            height: 45px;
            background-image: url("../../assets/img/common/backBlack.png");
            background-size: cover;
            z-index: 1;
        }
        .transparent{
            opacity: 0;
        }
        .download{
            position: absolute;
            right: 0;
            bottom: 0;
            width: 45px;
            height: 45px;
            background-image: url("../../assets/img/common/downloadHeader.png");
            background-size: cover;
            z-index: 1;
        }
        .search{
            font-size: 26px;
            position: absolute;
            right:14px;
            display: flex;
            justify-content: center;
            bottom: 8px;
            color: #fff;
            i{
                margin-left: 10px;
            }
        }
    }
    .headerDark{
        color: #333;
        .return{
            background-image: url("../../assets/img/common/backBlack.png");
        }

    }
}
</style>
